import { TablePagination } from '@mui/material'
import { warnDev } from '@/utils/warnDev'

import { BASE_TABLE_TEST_IDS } from '../TableBase.constants'
import type { Pagination as PaginationType } from '../TableBase.types'

type Props = {
  pagination: PaginationType
  onPaginationChange?: (page: number, pageSize: number) => void
}

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]

const getSafeNumber = (value: unknown, fallback = 0) => {
  if (typeof value !== 'number' || isNaN(value)) {
    warnDev(`getSafeNumber fallback triggered: received '${value}'`)
    return fallback
  }
  return value
}

export const Pagination = ({ pagination, onPaginationChange }: Props) => (
  <TablePagination
    component="div"
    count={getSafeNumber(pagination.total)}
    page={getSafeNumber(pagination.page)}
    onPageChange={(_, page) =>
      onPaginationChange?.(page, getSafeNumber(pagination.pageSize, ROWS_PER_PAGE_OPTIONS[0]))
    }
    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
    rowsPerPage={getSafeNumber(pagination.pageSize, ROWS_PER_PAGE_OPTIONS[0])}
    showLastButton
    showFirstButton
    onRowsPerPageChange={(e) =>
      onPaginationChange?.(getSafeNumber(pagination?.page), parseInt(e.target.value, 10))
    }
    data-testid={BASE_TABLE_TEST_IDS.pagination}
  />
)
